import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Segment, Dimmer, Loader } from 'semantic-ui-react';

import { SemanticPlaceholder, ServerSideRendered } from '../assets/components';
import { useShortcode } from '../assets/hooks';

export function TablePress({ data, ...rest }) {
  const { attributes } = data;
  const [ref, response, loaded, error] = useShortcode(`[table id="${attributes.tablePressId}" /]`);
  const [message, setMessage] = useState('Loading');
  const [tableNotFound, setTableNotFound] = useState(false);

  const { className, tagName: Tag, blockClass, tablePressId, anchor } = attributes;

  const blockClasses = classnames(blockClass, className, {});

  useEffect(() => {
    if (error) {
      setMessage(`Something went wrong :(`);
      return;
    }

    if (!loaded) {
      setMessage(`Loading`);
    }

    if (loaded && response && response.rendered.includes('not found')) {
      setMessage(
        `TablePress can't find table ${
          tablePressId === '' ? `without id` : `with id ${tablePressId}`
        }`,
      );
      setTableNotFound(true);
      return;
    } else {
      setTableNotFound(false);
      return;
    }
  }, [response, loaded, error]);

  const dimmed = !loaded || tableNotFound;

  return (
    <>
      <Tag id={anchor} ref={ref} className={blockClasses}>
        <Dimmer.Dimmable as={Segment} dimmed={dimmed} inverted={error}>
          <Dimmer active={dimmed}>
            <Loader>{message}</Loader>
          </Dimmer>

          {dimmed && <SemanticPlaceholder inverted={error} />}
          {loaded && !tableNotFound && (
            <ServerSideRendered data={{ rendered: response.rendered }} />
          )}
        </Dimmer.Dimmable>
      </Tag>
    </>
  );
}
